import React, { Fragment, useEffect, useRef, useState } from 'react';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter, commonActionHeader } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import EmployeesGrid from './EmployeesGrid';
import useEmployeesPresenter from './EmployeesPresenter';
import CreateEmployeeDialog from './CreateEmployeeDialog';
import { AddBox } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import inventoriesApi from '../../services/inventoriesApi';


const useStyles = makeStyles(theme => {
    return {
      ...commonFilter,
      ...commonActionHeader(theme),
    };
  });


const Employees = () => {
  const classes = useStyles();
  const tableRef = useRef();
  const location = useLocation();
  const [supplierCuit, setSupplierCuit] = useState('');
  const [supplierName, setSupplierName] = useState('');

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('supplierId');
  
  const getSupplier = () => {
    inventoriesApi.getSuppliers()
    .then(res =>{
      const supplier = res.find(e => e.id === id);
      setSupplierCuit(supplier.cuit);
      setSupplierName(supplier.businessName);
    } )
  }


  useEffect(() => {
    getSupplier();
  }, [])

  const [openEmployee, setOpenEmployee] = useState(false)
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useEmployeesPresenter(tableRef, id);


  return (
    <Fragment>

        <div className={classes.actionHeader}>

        <TextField
          title={`${supplierCuit} - ${supplierName}`}
          label='Proveedor'
          value={`${supplierCuit} - ${supplierName}`}
          InputProps={{ readOnly: true }}
          style={{
            position: 'absolute',
            left: 0,
            top: 0
          }}
        >
        </TextField>        

        <Button
          variant="contained"
          color="primary"
          className={classes.actionHeaderButton}
          startIcon={<AddBox />}
          style={{ marginLeft: '10px' }}
          onClick={() => setOpenEmployee(true)}>
          Agregar Empleado
        </Button>
        
      </div>
      <CreateEmployeeDialog open={openEmployee} setOpen={setOpenEmployee} supplierId={id} reloadGrid={gridFunctions.reloadGrid} />

      <ViewPortGridWrapper>
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <EmployeesGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
    
    </Fragment>
    
    
  );
};

export default Employees;